import type { OverlapType } from './siteProtectedAreasQuery';

/** How an area's relationship to the site reads in a list. */
export const describeOverlap = (overlapType: OverlapType | null): string => {
    switch (overlapType) {
        case 'OVERLAPPING':
            return 'Overlaps';
        case 'ADJACENT':
            return 'Adjacent';
        default:
            return '';
    }
};
